export const buildUserCreateUpdateInput = ({
    user,
    values,
    radioValue,
    canManageUserGroups,
}) => {
    if (!user?.id && !canManageUserGroups) return null;

    const input = {
        id: user?.id ? +user.id : undefined,
        ...values,
        subcontractor_id: radioValue === 'subcontractor'
            ? (values.subcontractor_id?.value || values.subcontractor_id)
            : undefined,
    };

    if (user?.id && !canManageUserGroups) delete input.role_id;

    return input;
};
